import { create } from 'zustand';
import { createJSONStorage, devtools, persist } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';
import { createGridBundleSlice } from './GridSlices/gridBundleSlice';
import { createMainGridSlice } from './GridSlices/gridMainSlice';
import { createSearchSlice } from './GridSlices/gridSearchSlice';
import { GridBundleSlice, GridMainSlice, GridSearchSlice, GridSellerClosetSlice } from './gridTypes';
import { createGridSellerClosetSlice } from './GridSlices/gridSellerSlice';

export const useGridFilterStore = create(
    devtools(
      immer<GridMainSlice & GridSearchSlice & GridBundleSlice & GridSellerClosetSlice>(
      (...a) => ({
          ...createMainGridSlice(...a),
          ...createSearchSlice(...a),
          ...createGridBundleSlice(...a),
          ...createGridSellerClosetSlice(...a)
          })
      ),
  ), 
)